export default function ReferralCoordinationIcon({ width = 17, height = 14, ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={width} height={height} viewBox='0 0 17 14' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M16.3739 4.0856L17 3.45952L16.3739 2.83343L13.5406 0L12.2884 1.25217L13.6103 2.57409H0.708293V4.34493H13.6103L12.2884 5.66683L13.5406 6.91896L16.3739 4.0856ZM0 10.5429L0.626084 11.169L3.45947 14.0023L4.71164 12.7502L3.38977 11.4283H16.2917V9.65746H3.38974L4.71165 8.33556L3.45947 7.08336L0.626078 9.91678L0 10.5429Z'
        fill='currentColor'
      />
    </svg>
  );
}
